module.exports = {
      id: "pre-blue-panel-usage",
      viewBox: "0 0 43 44",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#pre-blue-panel",
      toString: function () {
        return this.url;
      }
    }